<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-list
    v-if="activeItem&&dialogOpen"
    :style="(activeItem&&dialogOpen ? '' : 'opacity: 1;')+(
      $vuetify.breakpoint.md?'max-height: calc(100vh);':'max-height: calc(100vh);'
    )"
    :width="activeItem&&dialogOpen ? '100%' : ''"
    class="pa-4 mt-0 elevation-2 white--text"
    dense
    nav
    style="position: relative;overflow: scroll;height: 100%"
  >
    <div
      class="d-block overflow-hidden text-h4 mb-1 py-5 pl-3"
    >
      <div
        class="text-truncate"
      >
        {{ $t(activeItem.title) }}
      </div>
    </div>
    <v-list-item-group :style="itemLoading ? '' : 'opacity: 1;'">
      <template v-for="(firstItem,i) in activeItem.children">
        <template v-if="firstItem.children">
          <v-list-group
            :key="'firstItem'+i"
            append-icon="mdi-menu-down"
            color="grey darken-3"
          >
            <template
              #activator
            >
              <v-list-item-title
                :class="firstItem.title"
                style="font-size: 12px !important;"
              >
                {{ $t(firstItem.title) }}
              </v-list-item-title>
            </template>
            <template v-for="(secondItem,j) in firstItem.children">
              <template v-if="secondItem.children">
                <v-list-group
                  :key="'second'+j"
                  no-action
                  sub-group
                >
                  <template #activator>
                    <v-list-item>
                      <v-list-item-title
                        :class="secondItem.title"
                        style="font-size: 12px !important; width: 90% !important;"
                      >
                        {{ $t(secondItem.title) }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <navigation-list-item
                    v-for="(thirdItem,k) in secondItem.children"
                    :key="'third'+k"
                    :active="$route.path === activeItem.group + '/' + thirdItem.to"
                    :class="thirdItem.title"
                    :loading="thirdItem.loading"
                    :locked="thirdItem.locked"
                    :no-power="thirdItem.noPower"
                    :sub-btn="true"
                    :title="thirdItem.title"
                    @click="goto(thirdItem,secondItem.group);"
                  />
                </v-list-group>
              </template>

              <template v-else>
                <navigation-list-item
                  :key="'second'+j"
                  :active="$route.path === activeItem.group + '/' + secondItem.to"
                  :class="secondItem.title"
                  :loading="secondItem.loading"
                  :locked="secondItem.locked"
                  :no-power="secondItem.noPower"
                  :sub-btn="true"
                  :title="secondItem.title"
                  @click="goto(secondItem,firstItem.group);"
                />
              </template>
            </template>
          </v-list-group>
        </template>
        <template v-else>
          <navigation-list-item
            :key="'firstMenu'+i"
            :active="$route.path === activeItem.group + '/' + firstItem.to"
            :class="firstItem.title"
            :loading="firstItem.loading"
            :locked="firstItem.locked"
            :no-power="firstItem.noPower"
            :title="firstItem.title"
            @click="goto(firstItem,activeItem.group)"
          />
        </template>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script>
import NavigationListItem from '@/views/AppIndex/Widget/NavigationListItem.vue'

export default {
  name: 'NavigationList',
  components: { NavigationListItem },
  props: {
    activeItem: {},
    itemLoading: {},
    dialogOpen: {}
  },
  methods: {
    goto (item, group) {
      this.$emit('goto', item, group)
    }
  }
}
</script>

<style scoped>

</style>
